"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @see https://api-reference.kevin.eu/public/platform/v0.3#tag/General-service
 */
class GeneralService {
    constructor(client) {
        this._client = client;
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getCountries
     */
    getCountries() {
        return this._client.sendRequest(GeneralService.ROUTES.COUNTRIES, 'get');
    }
    /**
     * @see: https://api-reference.kevin.eu/public/platform/v0.3#operation/getBank
     */
    getBank(bankId) {
        return this._client.sendRequest(GeneralService.ROUTES.BANK, 'get', { pathParameters: { bankId } });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getBanks
     */
    getBanks(countryCode) {
        return this._client.sendRequest(GeneralService.ROUTES.BANKS, 'get', countryCode ? { queryParameters: { countryCode } } : undefined);
    }
    /**
     * @see: https://api-reference.kevin.eu/public/platform/v0.3#operation/getSavingsBanks
     */
    getSavingsBanks(bankId) {
        return this._client.sendRequest(GeneralService.ROUTES.SAVING_BANKS, 'get', { pathParameters: { bankId } });
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getPaymentMethods
     */
    getPaymentMethods() {
        return this._client.sendRequest(GeneralService.ROUTES.PAYMENT_METHODS, 'get');
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#operation/getProjectSettings
     */
    getProjectSettings() {
        return this._client.sendRequest(GeneralService.ROUTES.PROJECT_SETTINGS, 'get');
    }
}
GeneralService.ROUTES = {
    BANK: '/auth/banks/{bankId}',
    BANKS: '/auth/banks',
    SAVING_BANKS: '/auth/banks/{bankId}/savings',
    COUNTRIES: '/auth/countries',
    BANK_BY_CARD_NUMBER_PIECE: '/auth/banks/cards/{cardNumberPiece}',
    PAYMENT_METHODS: '/auth/paymentMethods',
    PROJECT_SETTINGS: '/auth/project/settings',
};
exports.default = GeneralService;
